import React, { useEffect, useState } from "react";
import axios from "axios";
import { useAuth, API } from "@/auth";

export default function CharacterPicker({ value, onChange, testIdPrefix = "char" }) {
 const [opts, setOpts] = useState([]);
 useEffect(() => { axios.get(`${API}/avatars`).then(r => setOpts(r.data)).catch(() => {}); }, []);
 return (
 <div>
 <div className="font-mono text-[10px] tracking-[0.3em] text-yt-muted mb-2">PICK YOUR FACE</div>
 <div className="grid grid-cols-2 md:grid-cols-4 gap-2">
 {opts.map(o => (
 <button type="button" key={o.key}
 data-testid={`${testIdPrefix}-${o.key}`}
 onClick={() => onChange(o.portrait)}
 className={`relative bg-yt-surface border overflow-hidden transition-all ${value === o.portrait ? "border-yt-yellow shadow-brutal-yellow" : "border-yt-border hover:border-yt-yellow"}`}>
 <div className="aspect-square bg-black overflow-hidden">
 <img src={o.portrait} alt={o.name} className="w-full h-full object-cover" />
 </div>
 <div className="p-2">
 <div className="font-display text-base tracking-tight">{o.name}</div>
 <div className="font-mono text-[9px] text-yt-muted leading-tight">{o.blurb}</div>
 </div>
 {value === o.portrait && <div className="absolute top-1 right-1 bg-yt-yellow text-black font-mono text-[9px] px-1.5 py-0.5">✓</div>}
 </button>
 ))}
 </div>
 <div className="mt-2 font-mono text-[10px] text-yt-muted">Upload-your-own-face · coming Phase 3</div>
 </div>
 );
}
